import React from 'react'

function Undo({ size }) {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" height={size} viewBox="0 0 24 24">
        <path
          fill="currentColor"
          d="M6.05 7.25l2.22-2.22A.75.75 0 0 0 7.2 3.97L4.43 6.75c-.69.68-.69 1.8 0 2.48l2.83 2.83A.75.75 0 0 0 8.32 11L6.07 8.75H16a4.25 4.25 0 1 1 0 8.5h-4a.75.75 0 1 0 0 1.5h4a5.75 5.75 0 0 0 0-11.5H6.05z"
        ></path>
      </svg>
    )
  }
  
  export default Undo
  
 